import React from 'react';
import { Appointment, needsGarageAnswer } from './appointmentUtils';
import { RequestModal } from './RequestModal';
import { AppointmentDrawer } from './AppointmentDrawer';

interface Props {
    appointment: Appointment;
    counterFirst?: boolean;     // ouvre directement « Proposer un autre créneau »
    lunch?: [string, string] | null;
    onClose: () => void;
    onChanged: () => void;
}

// Choisit la bonne vue : demande à traiter (fenêtre) ou rendez-vous en cours (panneau latéral)
export const AppointmentViewer: React.FC<Props> = ({ appointment, counterFirst, lunch, onClose, onChanged }) =>
    needsGarageAnswer(appointment)
        ? <RequestModal appointment={appointment} startInCounter={counterFirst} lunch={lunch} onClose={onClose} onChanged={onChanged} />
        : <AppointmentDrawer appointment={appointment} onClose={onClose} onChanged={onChanged} />;
